<template>
  <v-dialog :value="value" @input="$emit('input', $event)" maxWidth="800px" scrollable>
    <v-card>
      <v-card-title>
        <span class="title">{{ $t('Success') }}</span>
        <v-spacer />
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text :class="{'loading': loading}" style="min-height: 100px;">
        {{$t('ArtworkSubscribeForm.dialog')}}
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SubscriptionNotificationDialog',
  props: ["value", "loading"],
}
</script>

<style scoped>

</style>
